import * as moment from 'moment'

import sortTransactions from './sortTransactions'
import mapTransactions from './mapTransactions'
import generateIntervalActions from './generateIntervalActions'
import { toNumber as intervalTypeToNumber } from '../../constants/IntervalTypes'
import { LoanQueryResult } from '../../components/queries/LoanQuery'

type Loan = Exclude<LoanQueryResult['loan'], null>

export const processTransactions = (
  loan: Loan,
  currentDate: moment.Moment = moment()
) => {
  const transactions = loan.transactions
  const mappedTransactions = sortTransactions([
    ...mapTransactions(transactions),
    ...(loan.interval != null
      ? generateIntervalActions(
          intervalTypeToNumber[loan.interval],
          moment(loan.startedOn),
          loan.completedOn != null ? moment(loan.completedOn) : currentDate
        )
      : [])
  ])

  return mappedTransactions
}

export default processTransactions



// WEBPACK FOOTER //
// ./src/utils/transactions/processTransactions.tsx